import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e58dbd7c")

_pushScopeId("data-v-e58dbd7c")
const _hoisted_1 = { class: "mylist-folder-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MyListFolderListItem = _resolveComponent("MyListFolderListItem")
  const _component_draggable = _resolveComponent("draggable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_draggable, {
      list: _ctx.displayFolderList,
      disabled: false,
      handle: ".handle",
      "item-key": "id",
      onEnd: _ctx.dragEnd
    }, {
      item: _withId(({ element }) => [
        _createVNode(_component_MyListFolderListItem, {
          class: "mylist-folder-list-item",
          folderId: element.id,
          folderTitle: element.name,
          folderImageUrl: element.image,
          folderNum: element.numberOfItems,
          onOnClick: _ctx.selectFolder
        }, null, 8, ["folderId", "folderTitle", "folderImageUrl", "folderNum", "onOnClick"])
      ]),
      _: 1
    }, 8, ["list", "onEnd"])
  ]))
})